import { IconWrapper } from '../runtime';
export default IconWrapper('add-down', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M8 9.25V14.25M10.5 11.75H5.5M3.5 6.25C2.67157 6.25 2 5.57843 2 4.75L2 3.25C2 2.42157 2.67157 1.75 3.5 1.75L12.5 1.75C13.3284 1.75 14 2.42157 14 3.25V4.75C14 5.57843 13.3284 6.25 12.5 6.25L3.5 6.25Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});